import { render } from "./PurchaseStartedatError.vue?vue&type=template&id=1d7bf352&scoped=true"
import script from "./PurchaseStartedatError.vue?vue&type=script&lang=js"
export * from "./PurchaseStartedatError.vue?vue&type=script&lang=js"

import "./PurchaseStartedatError.vue?vue&type=style&index=0&id=1d7bf352&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d7bf352"

export default script